import { useTranslation } from 'react-i18next';
import Icons from '../../../../../common/widgets/Icons';
import { resources } from '../../../resources/resources';
import { Link } from 'react-router-dom';

export default function Social() {
  const { t: translate } = useTranslation();

  return (
    <div className="m-footer-social-links">
      <Link
        to={translate(resources.company.fBLink)}
        target="_blank"
        rel="noreferrer"
      >
        <Icons.MFb />
      </Link>
      <Link
        to={translate(resources.company.youTubeLink)}
        target="_blank"
        rel="noreferrer"
      >
        <Icons.MYt />
      </Link>
      <Link
        to={translate(resources.company.linkedInLink)}
        target="_blank"
        rel="noreferrer"
      >
        <Icons.MIn />
      </Link>
    </div>
  );
}
